import { render, staticRenderFns } from "./StockReceiveWholesaleSelector.vue?vue&type=template&id=4ace22c7&scoped=true&"
import script from "./StockReceiveWholesaleSelector.vue?vue&type=script&lang=ts&"
export * from "./StockReceiveWholesaleSelector.vue?vue&type=script&lang=ts&"
import style0 from "./StockReceiveWholesaleSelector.vue?vue&type=style&index=0&id=4ace22c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace22c7",
  null
  
)

export default component.exports